import { Panel, PanelSection } from 'foundations-components/transitional/components/Panel';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function OverlayPanel({
  isOpen,
  onClose,
  align,
  inlineSize,
  ariaCloseLabel,
  title,
  children,
  'data-test-id': dataTestId
}) {
  if (!isOpen) return null;
  return /*#__PURE__*/_jsxs(Panel, {
    align: align,
    inlineSize: inlineSize,
    "data-test-id": dataTestId,
    children: [/*#__PURE__*/_jsx(DialogCloseButton, {
      color: "icon-core-default",
      onClick: onClose,
      "aria-label": ariaCloseLabel
    }), /*#__PURE__*/_jsxs(PanelSection, {
      display: "flex",
      flex: "1",
      flexDirection: "column",
      paddingBlock: "600",
      gap: "400",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h2",
        color: "text-core-default",
        typography: "heading-300",
        children: title
      }), children]
    })]
  });
}